import PartnershipAdmin from '../views/PartnershipAdmin';
import AdminDashboard from '../views/admin/dashboard/Index';
import AdminAgents from '../views/admin/agents/Index';
import AdminAgentsEdit from '../views/admin/agents/Edit';

const prefix = 'partnership-admin';

export const PARTNERSHIP_ADMIN_ROUTES = {
  path: `/${prefix}`,
  name: prefix,
  component: PartnershipAdmin,
  redirect: { name: `${prefix}-dashboard` },
  meta: { title: 'Parnership Admin' },
  children: [
    {
      path: 'dashboard',
      name: `${prefix}-dashboard`,
      component: AdminDashboard,
      meta: { title: 'Partnership Admin - Dashboard' }
    },
    {
      path: 'agents',
      name: `${prefix}-agents`,
      component: AdminAgents,
      meta: { title: 'Admin - All Agents' }
    },
    {
      path: 'agents/new',
      name: `${prefix}-agents-create`,
      component: AdminAgentsEdit,
      meta: { title: 'Admin - Add New Agent' }
    },
    {
      path: 'agents/:user_id',
      name: `${prefix}-agents-edit`,
      component: AdminAgentsEdit,
      meta: { title: 'Admin - Edit Agent' }
    },
  ]
};
